/* eslint-disable no-unused-vars */
import "@images/favicon.ico";
import 'bootstrap/dist/css/bootstrap.min.css';  // Bootstrap CSS
import 'sweetalert2/dist/sweetalert2.min.css';  // SweetAlert2 CSS
import "@styles/theme";
import "./pages/global.js"; import "./pages/login.js"; import "./pages/register.js"; import "./pages/search.js"; import "./pages/youtube.js";
import 'bootstrap';  // Bootstrap JS for modals, dropdowns, etc.
import gsap from "gsap";
import AOS from "aos";
import Swiper from "swiper";
import Shuffle from "shufflejs";
import Mmenu from "mmenu-js/src/mmenu";
import Swal from "sweetalert2";

// Swup removed as requested to simplify CF7 integration
// import Swup from "swup"; (Removed)

document.addEventListener("DOMContentLoaded", () => {
  initializePageFeatures();
});

function initializePageFeatures() {
  initAnimations();
  initBootstrap();
  initMmenu();
  initSwiperSlider();
  initShuffle();
  setupHideHeaderOnScroll();
  setupGsap404();
  initContactForm7();

  if (typeof window.initializeYouTubePlayers === "function") {
    window.initializeYouTubePlayers();
  }
}

/**
 * Khởi tạo hoạt ảnh GSAP và AOS
 */
function initAnimations() {
  //   // AOS
  AOS.init({
    duration: 400,
  });
}

/**
 * Initialize Bootstrap components (modals, etc.)
 */
function initBootstrap() {
  // Bootstrap is already imported globally
  // Modals will work automatically with data-bs-toggle attributes
  // No manual initialization needed for Bootstrap 5
  console.log('[Bootstrap] Components ready');
}

function initMmenu() {
  new Mmenu("#mobile_menu", {
    extensions: ["position-bottom", "fullscreen", "theme-black", "border-full"],
    searchfield: false,
    counters: false,
  });
}

function initSwiperSlider() {
  setTimeout(() => {
    new Swiper(".sliders", {
      spaceBetween: 30,
      centeredSlides: true,
      effect: "fade",
      speed: 1500,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
  }, 500);
}

function initShuffle() {
  const containers = document.querySelectorAll(".menu-wrapper, .menu-wrapper-2");
  if (containers.length === 0) return;

  console.log('[Shuffle] Containers found:', containers.length);

  // Small delay to ensure CSS layout is settled
  setTimeout(() => {
    containers.forEach((container) => {
      if (container.dataset.shuffleInit === "true") return;

      const images = container.querySelectorAll("img");
      let loadedCount = 0;
      const totalImages = images.length;

      function initializeShuffleInstance() {
        console.log('[Shuffle] Initializing for:', container.className);
        
        try {
          const shuffleInstance = new Shuffle(container, {
            itemSelector: ".loop-food",
            speed: 400,
            easing: 'ease-out',
            isCentered: false, // Ensure it doesn't try to center and mess up widths
          });

          container.dataset.shuffleInit = "true";
          
          // Force a layout recalculation after a short tick
          requestAnimationFrame(() => {
            shuffleInstance.layout();
            console.log('[Shuffle] Initial layout call');
          });

          // Handle lazyloaded event
          document.addEventListener("lazyloaded", () => {
            shuffleInstance.update();
          });

          // Handle Filtering
          const section = container.closest('section');
          const filterItems = section ? section.querySelectorAll(".menu-filter li") : document.querySelectorAll(".menu-filter li");
          
          if (filterItems.length > 0) {
            filterItems.forEach((item) => {
              item.addEventListener("click", function (e) {
                e.preventDefault();
                const filterValue = this.getAttribute("data-filter");
                console.log('[Shuffle] Filter clicked:', this.textContent, 'Value:', filterValue);
                
                filterItems.forEach((li) => li.classList.remove("active"));
                this.classList.add("active");

                if (!filterValue || filterValue === "*" || filterValue.toLowerCase() === "all") {
                  shuffleInstance.filter(Shuffle.ALL_ITEMS);
                } else {
                  // USE CUSTOM FILTER FUNCTION to avoid Shuffle's internal JSON.parse of data-groups
                  const className = filterValue.replace(".", "");
                  shuffleInstance.filter((element) => {
                    return element.classList.contains(className);
                  });
                }
              });
            });
          }
          
          // Update on resize (debounced)
          let resizeTimer;
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
              shuffleInstance.update();
            }, 100);
          });

          // Final safety net update
          setTimeout(() => shuffleInstance.layout(), 1000);

        } catch (error) {
          console.error('[Shuffle] Initialization failed:', error);
        }
      }

      if (totalImages === 0) {
        initializeShuffleInstance();
      } else {
        const checkImage = () => {
          loadedCount++;
          if (loadedCount >= totalImages) {
            initializeShuffleInstance();
          }
        };

        images.forEach((img) => {
          if (img.complete) {
            checkImage();
          } else {
            img.addEventListener("load", checkImage);
            img.addEventListener("error", checkImage);
          }
        });
        
        // Timeout for image loading to avoid hanging
        setTimeout(() => {
          if (container.dataset.shuffleInit !== "true") {
            console.warn('[Shuffle] Image load timeout, initializing anyway');
            initializeShuffleInstance();
          }
        }, 3000);
      }
    });
  }, 100);
}

// Global flag to ensure CF7 events are only added once
let cf7EventsInitialized = false;

/**
 * Initialize Contact Form 7 with SweetAlert2
 * Handle form submission with loading and success/error messages
 */
function initContactForm7() {
  // We no longer need to manually init wpcf7 because we removed Swup.
  // The standard plugin script will handle the form initialization.
  
  // Only add document-level event listeners once
  if (!cf7EventsInitialized) {
    // Listen to click on submit button to show loading and validate
    document.addEventListener('click', function(event) {
      // Check if clicked element is CF7 submit button
      const submitBtn = event.target.closest('.wpcf7-submit');
      if (!submitBtn) return;
      
      const form = submitBtn.closest('.wpcf7-form');
      if (!form) return;
      
      console.log('[CF7] Submit button clicked - validating date/time');
      
      const dateInput = form.querySelector('input[name="date_booking"]');
      const timeSelect = form.querySelector('select[name="hour_booking"]');
      
      // Always validate date/time if fields exist
      if (dateInput || timeSelect) {
        const today = new Date().toISOString().split('T')[0];
        const now = new Date();
        
        // Validate date
        if (dateInput) {
          const selectedDate = dateInput.value;
          console.log('[CF7] Checking date:', selectedDate, 'vs today:', today);
          
          if (!selectedDate || selectedDate < today) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            
            console.log('[CF7] BLOCKED: Invalid date detected');
            
            Swal.fire({
              icon: "error",
              title: "Invalid Date",
              text: "Please select today or a future date for your booking.",
              confirmButtonText: "Close",
              confirmButtonColor: "#dc3545"
            });
            
            // Reset to today
            dateInput.value = today;
            
            return false;
          }
        }
        
        // Validate time
        if (dateInput && timeSelect && dateInput.value && timeSelect.value) {
          const selectedDate = dateInput.value;
          const selectedTime = timeSelect.value;
          
          const bookingDateTime = new Date(selectedDate + ' ' + selectedTime);
          console.log('[CF7] Checking datetime:', bookingDateTime, 'vs now:', now);
          
          // Check if booking date/time is in the past (with 1 minute buffer)
          if (bookingDateTime <= now) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            
            console.log('[CF7] BLOCKED: Past time detected');
            
            Swal.fire({
              icon: "error",
              title: "Invalid Time",
              text: "Please select a future time for your booking.",
              confirmButtonText: "Close",
              confirmButtonColor: "#dc3545"
            });
            
            return false;
          }
        }
      }
      
      console.log('[CF7] Validation passed, showing loading');
      
      // Show loading alert - will be replaced by result alert
      setTimeout(() => {
        Swal.fire({
          title: "Sending...",
          text: "Please wait a moment",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      }, 100);
    }, true); // Use capture phase
    
    // Also listen to wpcf7submit to close loading
    document.addEventListener("wpcf7submit", function(event) {
      console.log('[CF7] wpcf7submit event fired - form submission completed');
    }, false);

    // Event triggered when mail is sent successfully
    document.addEventListener("wpcf7mailsent", function(event) {
      console.log('[CF7] wpcf7mailsent event triggered');
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Thank you for contacting us. We will respond as soon as possible.",
        confirmButtonText: "Close",
        confirmButtonColor: "#28a745"
      });
    }, false);

    // Event triggered when validation fails
    document.addEventListener("wpcf7invalid", function(event) {
      console.log('[CF7] wpcf7invalid event triggered');
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check your information and try again.",
        confirmButtonText: "Close",
        confirmButtonColor: "#dc3545"
      });
    }, false);

    // Event triggered when spam is detected
    document.addEventListener("wpcf7spam", function(event) {
      console.log('[CF7] wpcf7spam event triggered');
      Swal.fire({
        icon: "warning",
        title: "Spam Detected",
        text: "Your request was rejected due to spam detection.",
        confirmButtonText: "Close",
        confirmButtonColor: "#ffc107"
      });
    }, false);

    // Event triggered when mail failed to send
    document.addEventListener("wpcf7mailfailed", function(event) {
      console.log('[CF7] wpcf7mailfailed event triggered');
      Swal.fire({
        icon: "error",
        title: "Sending Failed",
        text: "An error occurred while sending. Please try again later.",
        confirmButtonText: "Close",
        confirmButtonColor: "#dc3545"
      });
    }, false);

    cf7EventsInitialized = true;
    console.log('[Contact Form 7] Event listeners initialized');
  }

  // Set min date for booking date input and disable past hours
  const dateInputs = document.querySelectorAll('input[name="date_booking"]');
  const timeSelects = document.querySelectorAll('select[name="hour_booking"]');
  
  dateInputs.forEach(dateInput => {
    // Set min date to today and readonly to prevent manual typing
    const today = new Date().toISOString().split('T')[0];
    dateInput.setAttribute('min', today);
    dateInput.setAttribute('value', today);
    dateInput.value = today;
    
    console.log('[CF7] Setting up date validation for:', dateInput.name);
    
    // Validate and block past dates on input/change
    const validateDateInput = function(e) {
      console.log('[CF7] Date input validation triggered, value:', dateInput.value);
      const selectedDate = dateInput.value;
      if (!selectedDate) {
        dateInput.value = today;
        return;
      }
      
      const currentToday = new Date().toISOString().split('T')[0];
      
      // If date is in the past, reset to today
      if (selectedDate < currentToday) {
        console.log('[CF7] Past date detected, resetting to today');
        dateInput.value = currentToday;
        
        Swal.fire({
          icon: "warning",
          title: "Invalid Date",
          text: "You cannot select a past date. The date has been set to today.",
          confirmButtonText: "OK",
          confirmButtonColor: "#ffc107",
          timer: 3000,
          timerProgressBar: true
        });
      }
      
      // Update available hours
      const timeSelect = dateInput.closest('form').querySelector('select[name="hour_booking"]');
      if (timeSelect) {
        updateAvailableHours(dateInput, timeSelect);
      }
    };
    
    // Multiple event listeners to catch all changes
    dateInput.addEventListener('change', validateDateInput);
    dateInput.addEventListener('blur', validateDateInput);
    dateInput.addEventListener('input', validateDateInput);
    
    // Use MutationObserver to watch for value changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          validateDateInput();
        }
      });
    });
    
    observer.observe(dateInput, {
      attributes: true,
      attributeFilter: ['value']
    });
    
    // Watch for any value changes using setInterval as fallback
    let lastValue = dateInput.value;
    setInterval(() => {
      if (dateInput.value !== lastValue) {
        console.log('[CF7] Date value changed via interval check');
        lastValue = dateInput.value;
        validateDateInput();
      }
    }, 500);
  });
  
  // Initial update for available hours on page load
  // Run immediately and after a short delay to ensure CF7 is fully loaded
  const runInitialUpdate = () => {
    const dateInputs = document.querySelectorAll('input[name="date_booking"]');
    dateInputs.forEach(dateInput => {
      const timeSelect = dateInput.closest('form')?.querySelector('select[name="hour_booking"]');
      if (timeSelect) {
        // Set default date to today if empty
        if (!dateInput.value) {
          const today = new Date().toISOString().split('T')[0];
          dateInput.value = today;
        }
        updateAvailableHours(dateInput, timeSelect);
      }
    });
  };
  
  runInitialUpdate();
  setTimeout(runInitialUpdate, 500);
  setTimeout(runInitialUpdate, 1000);
  
  // Validate when time changes
  timeSelects.forEach(timeSelect => {
    timeSelect.addEventListener('change', function() {
      const dateInput = timeSelect.closest('form').querySelector('input[name="date_booking"]');
      if (dateInput) {
        validateBookingDateTime(dateInput, timeSelect);
      }
    });
  });

  console.log('[Contact Form 7] SweetAlert2 integration initialized');
}

/**
 * Update available hours based on selected date
 * Disable past hours if today is selected
 */
function updateAvailableHours(dateInput, timeSelect) {
  if (!dateInput || !timeSelect) return;
  
  let selectedDate = dateInput.value;
  const today = new Date().toISOString().split('T')[0];
  
  // If no date selected, set to today
  if (!selectedDate) {
    dateInput.value = today;
    selectedDate = today;
  }
  
  // If selected date is in the past, reset to today
  if (selectedDate < today) {
    dateInput.value = today;
    selectedDate = today;
  }
  
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  
  // Get all options
  const options = timeSelect.querySelectorAll('option');
  let firstEnabledValue = '';
  
  options.forEach(option => {
    // Skip empty/placeholder option
    if (!option.value) {
      option.disabled = false;
      return;
    }
    
    let isDisabled = false;
    
    // Only apply time restrictions if selected date is today
    if (selectedDate === today) {
      const timeValue = option.value;
      let hour = -1;
      let minute = 0;
      
      // Regex to parse time. Supports: "14:00", "02:00 PM", "2 PM"
      const match12 = timeValue.match(/(\d+)(?::(\d+))?\s*(AM|PM)/i);
      const match24 = timeValue.match(/(\d+):(\d+)/);
      
      if (match12) {
        hour = parseInt(match12[1]);
        minute = match12[2] ? parseInt(match12[2]) : 0;
        const period = match12[3].toUpperCase();
        
        if (period === 'PM' && hour !== 12) hour += 12;
        if (period === 'AM' && hour === 12) hour = 0;
      } else if (match24) {
        // 24-hour format
        hour = parseInt(match24[1]);
        minute = parseInt(match24[2]);
      }
      
      // If parsing succeeded
      if (hour !== -1) {
        // Disable if time has passed
        if (hour < currentHour || (hour === currentHour && minute <= currentMinute)) {
          isDisabled = true;
        }
      }
    } 
    
    // Apply state
    option.disabled = isDisabled;
    
    if (isDisabled) {
      option.style.color = '#ccc';
      // option.style.textDecoration = 'line-through';
    } else {
      option.style.color = '';
      // option.style.textDecoration = '';
      if (!firstEnabledValue) firstEnabledValue = option.value;
    }
  });
  
  // If current selection is disabled, auto-select first available
  if (timeSelect.value && timeSelect.selectedOptions[0]?.disabled) {
    if (firstEnabledValue) {
      timeSelect.value = firstEnabledValue;
    } else {
      timeSelect.value = ''; // No options available
    }
  }
  
  console.log('[CF7] Updated available hours for date:', selectedDate);
}

/**
 * Validate booking date and time
 * Check if selected date/time is not in the past
 */
function validateBookingDateTime(dateInput, timeSelect) {
  if (!dateInput || !timeSelect) return true;
  
  const selectedDate = dateInput.value;
  const selectedTime = timeSelect.value;
  
  if (!selectedDate) {
    // Set to today if no date
    const today = new Date().toISOString().split('T')[0];
    dateInput.value = today;
    return true;
  }
  
  // Check if date is in the past
  const today = new Date().toISOString().split('T')[0];
  if (selectedDate < today) {
    dateInput.value = today;
    Swal.fire({
      icon: "warning",
      title: "Invalid Date",
      text: "You cannot select a past date. The date has been set to today.",
      confirmButtonText: "OK",
      confirmButtonColor: "#ffc107",
      timer: 3000
    });
    updateAvailableHours(dateInput, timeSelect);
    return false;
  }
  
  if (!selectedTime) return true;
  
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  
  // Parse selected time to hours and minutes
  let hour = -1;
  let minute = 0;
  
  // Regex to parse time. Supports: "14:00", "02:00 PM", "2 PM"
  const match12 = selectedTime.match(/(\d+)(?::(\d+))?\s*(AM|PM)/i);
  const match24 = selectedTime.match(/(\d+):(\d+)/);
  
  if (match12) {
    hour = parseInt(match12[1]);
    minute = match12[2] ? parseInt(match12[2]) : 0;
    const period = match12[3].toUpperCase();
    
    if (period === 'PM' && hour !== 12) hour += 12;
    if (period === 'AM' && hour === 12) hour = 0;
  } else if (match24) {
    hour = parseInt(match24[1]);
    minute = parseInt(match24[2]);
  }
  
  // If parsing failed, assume valid (or handle error) - choosing to be permissive if format is unknown
  if (hour === -1) return true;
  
  const selectedDateStr = dateInput.value;
  // Only check time if selected date is today
  if (selectedDateStr === today) {
    if (hour < currentHour || (hour === currentHour && minute <= currentMinute)) {
      // Show warning and reset time
      Swal.fire({
        icon: "warning",
        title: "Invalid Time",
        text: "This time has already passed. Please select a future time.",
        confirmButtonText: "OK",
        confirmButtonColor: "#ffc107",
        timer: 3000
      }).then(() => {
        // Find next available time
        const options = timeSelect.querySelectorAll('option');
        const firstEnabled = Array.from(options).find(opt => !opt.disabled && opt.value);
        if (firstEnabled) {
          timeSelect.value = firstEnabled.value;
        } else {
          timeSelect.value = '';
        }
      });
      
      return false;
    }
  }
  
  return true;
}

function setupGsap404() {
  gsap.set("svg", { visibility: "visible" });

  gsap.to("#spaceman", {
    y: 5,
    rotation: 2,
    yoyo: true,
    repeat: -1,
    ease: "sine.inOut",
    duration: 1,
  });

  gsap.to("#starsBig line", {
    rotation: "random(-30,30)",
    transformOrigin: "50% 50%",
    yoyo: true,
    repeat: -1,
    ease: "sine.inOut",
  });

  gsap.fromTo(
    "#starsSmall g",
    { scale: 0 },
    {
      scale: 1,
      transformOrigin: "50% 50%",
      yoyo: true,
      repeat: -1,
      stagger: 0.1,
    },
  );

  gsap.to("#circlesSmall circle", {
    y: -4,
    yoyo: true,
    duration: 1,
    ease: "sine.inOut",
    repeat: -1,
  });

  gsap.to("#circlesBig circle", {
    y: -2,
    yoyo: true,
    duration: 1,
    ease: "sine.inOut",
    repeat: -1,
  });

  gsap.set("#glassShine", { x: -68 });
  gsap.to("#glassShine", {
    x: 80,
    duration: 2,
    rotation: -30,
    ease: "expo.inOut",
    transformOrigin: "50% 50%",
    repeat: -1,
    repeatDelay: 8,
    delay: 2,
  });
}

function setupHideHeaderOnScroll() {
  let lastScrollTop = 0;
  let header = document.getElementById("header");
  let scrollTimeout;

  window.addEventListener("scroll", function () {
    clearTimeout(scrollTimeout);

    let currentScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop > lastScrollTop) {
      header.classList.add("hidden");
    } else {
      header.classList.add("hidden");
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;

    scrollTimeout = setTimeout(() => {
      header.classList.remove("hidden");
    }, 500);
  });
}
